import { Box, Typography } from '@mui/material';
import AudioPlayer from 'toolkit/media/audio-player';
import { themeColors } from 'toolkit/styles/colors';

interface FeedVoicemailProps {
  fileId: string;
  transcription?: string;
}

export const FeedVoicemail = ({
  fileId,
  transcription,
}: FeedVoicemailProps) => {
  return (
    <Box
      sx={{
        padding: '16px',
        backgroundColor: themeColors.inverseOnSurface,
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      <Box>
        <AudioPlayer fileId={fileId} />
      </Box>
      {!!transcription && (
        <Box
          sx={{
            padding: '8px 0px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}
        >
          <Typography variant="labelLarge">Voicemail transcription</Typography>
          <Typography variant="bodyMedium">{transcription}</Typography>
        </Box>
      )}
    </Box>
  );
};
